/**
 * Collections: storefront shortcuts within one product type (Business, Gaming, MacBooks…),
 * declared on the type in the registry (lib/catalog/productTypes `collections`) and reached
 * as `?cat=<id>` on the type's shop. Pure: no I/O.
 *
 * A collection's `match` is data, applied by the server in the query (lib/catalog/attributeSearch
 * MATCHERS, MERCH-86); the storefront only names and links collections.
 */

/** The type's collections ([] when it declares none). */
export const collectionsOf = (type) => (type && Array.isArray(type.collections) ? type.collections : []);

/** One collection of the type by id, or null. */
export const collectionOf = (type, id) => (id ? collectionsOf(type).find((c) => c.id === id) || null : null);

